import { render, staticRenderFns } from "./TwoFactorConfigComponent.vue?vue&type=template&id=3339fa99&scoped=true&"
import script from "./TwoFactorConfigComponent.vue?vue&type=script&lang=ts&"
export * from "./TwoFactorConfigComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TwoFactorConfigComponent.vue?vue&type=style&index=0&id=3339fa99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3339fa99",
  null
  
)

export default component.exports